var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-button',{attrs:{"size":"is-small","type":"is-primary","disabled":_vm.disabled},on:{"click":_vm.downloadFile}},[_c('b-icon',{attrs:{"icon":"file-download"}}),_c('span',[_vm._v(_vm._s(_vm.$t("DownloadTemplate")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }